import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import { Skeleton } from '@radix-ui/themes';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Container from './Container';

export const BaseStatistics: React.FC<{
  winPercentage?: number;
  matchesWon?: number;
  matchesLost?: number;
  fitpPoints?: number;
  loading: boolean;
  fitPlayerProfileId?: number;
  newYearMatches?: string;
}> = ({ winPercentage, matchesWon, matchesLost, fitpPoints, fitPlayerProfileId, loading, newYearMatches }) => {
  const itemClassName = 'gap-2 p-3 rounded-xl border border-solid border-neutral-neutral-2';
  const labelClassName = 'self-stretch text-neutral-neutral-8 text-sm  font-medium tracking-normal';
  const contentClassName =
    'self-stretch text-neutral-neutral-alpha-12 text-3xl md:text-4xl  font-bold tracking-tighter leading-9 md:leading-10';
  return (
    <Container title='Statistiche base'>
      <div id='4columns' className='grid w-full grid-cols-2 flex-wrap items-start gap-2 self-stretch md:grid-cols-4'>
        <div id='Win%' className={classNames(itemClassName, 'bg-white')}>
          <div id='title1' className={labelClassName}>
            Vittorie
          </div>
          <Skeleton loading={loading} className='h-10 w-20'>
            <div id='value1' className={contentClassName}>
              {winPercentage}%
            </div>
          </Skeleton>
        </div>
        <div id='Win' className={classNames(itemClassName, 'bg-white')}>
          <div id='title2' className={labelClassName}>
            Partite vinte
          </div>
          <Skeleton loading={loading} className='h-10 w-20'>
            <div id='value2' className={contentClassName}>
              {matchesWon}
            </div>
          </Skeleton>
        </div>
        <div id='Loss' className={classNames(itemClassName, 'bg-white')}>
          <div id='title3' className={labelClassName}>
            Partite perse
          </div>
          <Skeleton loading={loading} className='h-10 w-20'>
            <div id='value3' className={contentClassName}>
              {matchesLost}
            </div>
          </Skeleton>
        </div>
        <div id='Points' className={classNames(itemClassName, 'bg-accent-accent-3')}>
          <div id='title4' className={labelClassName}>
            Punti FITP
          </div>
          <Skeleton loading={loading} className='h-10 w-20'>
            <div id='value4' className={contentClassName}>
              {fitpPoints}
            </div>
          </Skeleton>
        </div>
      </div>
      <div className='text-accent-accent-9 mt-3 cursor-pointer text-sm font-bold'>
        {newYearMatches ? (
          <Link to={`/giocatore/${fitPlayerProfileId}/partite`}>
            Scopri le partite e calcoli dell'anno FITP {newYearMatches}
            <ArrowTopRightIcon />
          </Link>
        ) : (
          <Link to={`/giocatore/${fitPlayerProfileId}/statistiche`}>
            Scopri tutte le statistiche
            <ArrowTopRightIcon />
          </Link>
        )}
      </div>
    </Container>
  );
};

export default BaseStatistics;
